module.exports = __webpack_public_path__ + "img/zm.b475659b.svg";